import React, { useState, createContext, useContext, useEffect, useCallback } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import { APIRequestContext } from '../../../wrappers/APIRequestContext'
import toast from '../../../elem/Toast'
import withConfig from '../../../wrappers/withConfig'
import { UserContext } from '../../../wrappers/UserContext'
import { DataContext } from '../DataContext'
import actions from '../../../../utils/submissions/actions'
import { EDDDataContext } from './EDDDataContext'
import { unexpectedErrorText } from '../../../../utils/submissions/helperText'
import Toast from '../../../elem/Toast'

const ExistingEDDDataContext = createContext(null)

const ExistingEDDDataContextProvider = ({ config, children }) => {
    const { authenticatedFetch } = useContext(APIRequestContext)
    const { setActiveAgency, setIsSubmitting, submissionState, initializeState} = useContext(DataContext)
    const { setUploadId } = useContext(EDDDataContext)
    const { user } = useContext(UserContext)
    const [data, setData] = useState([])
    const [ uploadData, setUploadData ] = useState({})
    const [loading, setLoading] = useState([])
    const { API_URL } = config
    const { uploadId } = useParams()
    const history = useHistory()
    const [denied, setDenied] = useState(false)

    useEffect(() => {
        setData(submissionState['EDD'])
    }, [submissionState])

    useEffect(() => {
        if (uploadId) {
            setLoading(true)
            authenticatedFetch(`${API_URL}/upload/eddData?uploadId=${uploadId}`)
                .then(async response => {
                    if (response.ok) {
                        return response.json()
                    } else {
                        const error = await response.text()
                        throw new Error(error)
                    }
                })
                .then(response => {
                    setActiveAgency(response.upload.upload.AgencyCode)
                    initializeState({ EDD: response.edd })
                    setUploadData(response.upload.upload)
                    setUploadId(uploadId)
                })
                .catch(e => {
                    Toast({
                        level: 'error',
                        message: unexpectedErrorText,
                        autoClose: false,
                        alert: true,
                    })
                    toast({
                        level: 'error',
                        message:
                            'Existing EDD Data: ' +
                            (e.message
                                ? e.message
                                : 'Unable to connect to the server. Please try again later.'),
                    })
                })
                .finally(() => setLoading(false))
        }
    }, [uploadId])

    const rejectUpload = useCallback((comments) => {
        if (uploadId && user && user.profile) {
            setDenied(true)
            actions.reject(authenticatedFetch, API_URL, history, uploadId, comments, user.profile.name, () => setDenied(false))
        }
    }, [uploadId, user])

    const approveUpload = useCallback(comments => {
        if (uploadId && user && user.profile) {
            setIsSubmitting(true)
            actions.approve(authenticatedFetch, API_URL, history, uploadId, comments, () => setIsSubmitting(false))
        }
    }, [uploadId, user])

    return (
        <ExistingEDDDataContext.Provider value={{ loading, data, setData, rejectUpload, approveUpload, uploadData, denied, setDenied }}>
            {children}
        </ExistingEDDDataContext.Provider>
    )
}

export { ExistingEDDDataContext }
export default withConfig(ExistingEDDDataContextProvider)
